// extracted by mini-css-extract-plugin
export default {"arrowBack":"BackRegArrow__arrowBack--2Oo"};